<template>
  <TsImage
    :src="props.src"
    :alt="props.alt"
    loading="lazy"
    width="105"
    height="105"
    class="min-w-[105px] max-h-[105px] object-cover"
  />
</template>

<script lang="ts" setup>
type Props = {
  src?: string;
  alt?: string;
};

const props = defineProps<Props>();
</script>
